import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { RBAC_EMPLOYEE_GROUP_OPTIONS_ENDPOINT } from '../api/api-endpoints';
import { RestApiService } from '../api/rest-api.service';
import { formatString } from '../utils/string.utils';
import { AutocompleteOption } from '../../shared/inputs/autocomplete-select/autocomplete-select.component';

@Injectable({
  providedIn: 'root',
})
export class EmployeeGroupMemberOptionsService {
  private readonly requests = new Map<string, Promise<AutocompleteOption[]>>();
  private readonly loaded = new Map<string, AutocompleteOption[]>();

  constructor(private readonly api: RestApiService) {}

  options(kind: string): Promise<AutocompleteOption[]> {
    const cached = this.requests.get(kind);
    if (cached) return cached;

    const request = firstValueFrom(
      this.api.get<AutocompleteOption[]>(formatString(RBAC_EMPLOYEE_GROUP_OPTIONS_ENDPOINT, kind)),
    ).then((options) => {
      this.loaded.set(kind, options);
      return options;
    }).catch((error) => {
      this.requests.delete(kind);
      throw error;
    });
    this.requests.set(kind, request);
    return request;
  }

  async preload(kinds: readonly string[]): Promise<void> {
    await Promise.all(kinds.map((kind) => this.options(kind)));
  }

  label(kind: string, id: string | null | undefined): string {
    if (kind === 'all') return 'All employees';
    const option = this.loaded.get(kind)?.find((candidate) => candidate.value === id);
    return option?.label ?? (id ? 'Unavailable record' : 'Unselected');
  }
}
